<template>
  <div style="font-size: 20px; font-weight: 500;text-align: center;margin-top: 80px;">
    暂不支持的配置类型
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>

</style>
